export default "__VITE_ASSET__Dr75PLy2__"